<div class="scorecard-container">
  <div class="scorecard-content">
    <div class="legislator-card">
      <div class="legislator-info">
        <img [src]="scorecard.headshotUrl" [alt]="scorecard.name" class="headshot" (error)="onImageError($event)">
        <div class="name-section">
          <h2>{{ scorecard.name.split(',')[0] }}</h2>
          <p class="party-state">{{ scorecard.name.split(',')[1] }}</p>
        </div>
      </div>

      @if (isVacant) {
        <div class="voting-history">
          @for (vote of scorecard.votingHistory; track vote.name) {
            <div class="vote-item">
              <div class="vote-left">
                <div class="legislation-name">
                  {{ vote.name }}
                  <span class="info-icon" [matTooltip]="vote.description" matTooltipPosition="above" matTooltipClass="custom-tooltip">
                    <i class="material-icons">info_outline</i>
                  </span>
                </div>
              </div>
              <div class="vote-right">
                <span class="vote-position" [ngClass]="getVoteClass(vote.withIbewVote)">
                  {{ vote.withIbewVote }}
                </span>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="vacant-note">
          {{ scorecard.notes }}
        </div>
      }

      @if (isVacant) {
        <div class="score-section">
          <div class="score" [ngClass]="scoreClass">
            Score: {{ score }}%
          </div>
        </div>
      }

      @if (!!specialMessage) {
        <p class="special-message">
          {{ specialMessage }}
        </p>
      }
    </div>
  </div>
</div>